import { useCallback } from "react";
import { useAxiosInstances } from "../axios-instance";

export interface IConsultaDossieRequest {
  documento: string;
}

export interface IRegistrarOptinAcordoRequest {
  idVeles: number;
  deAcordo: boolean;
}

export interface IConsultaOnlineRequest {
  documento: string;
  dataNascimento?: string;
  dataAbertura?: string;
}

export const useDossieRepository = () => {
  const { axiosAuthInstance } = useAxiosInstances();

  const consultaDossiePF = useCallback(async (data: IConsultaDossieRequest) => {
    return axiosAuthInstance.post("/dossie/pf", data);
  }, [axiosAuthInstance]);

  const consultaDossiePJ = useCallback(async (data: IConsultaDossieRequest) => {
    return axiosAuthInstance.post("/dossie/pj", data);
  }, [axiosAuthInstance]);

  const registrarOptinAcordo = useCallback(async (data: IRegistrarOptinAcordoRequest) => {
    return axiosAuthInstance.post("/dossie/optin-acordo", data);
  }, [axiosAuthInstance]);

  const consultarReceitaOnlinePF = useCallback(async (data: IConsultaOnlineRequest) => {
    return axiosAuthInstance.post("/dossie/consulta-online/pf", data);
  }, [axiosAuthInstance]);

  const consultarReceitaOnlinePJ = useCallback(async (data: IConsultaOnlineRequest) => {
    return axiosAuthInstance.post("/dossie/consulta-online/pj", data);
  }, [axiosAuthInstance]);

  return {
    consultaDossiePF,
    consultaDossiePJ,
    registrarOptinAcordo,
    consultarReceitaOnlinePF,
    consultarReceitaOnlinePJ,
  };
};
